import { ROUTES } from "@/app/routes";
import { NavigationButton } from "@/pages/home/NavigationButton";

const navigationItems = [
  { label: "About Me", to: ROUTES.about },
  { label: "Commissions", to: ROUTES.commissions },
  { label: "Portfolio", to: ROUTES.portfolio },
  { label: "Contact Me", to: ROUTES.contact },
  { label: "Socials", to: ROUTES.socials },
];

export function PrimaryNavigation({ commissionsOpen, isLoading }: { commissionsOpen: boolean; isLoading?: boolean }) {
  return (
    <div className="w-full max-w-6xl">
      {!isLoading && !commissionsOpen && (
        <p className="mb-4 rounded border border-cyan-300/30 bg-cyan-300/10 px-3 py-2 text-center font-display text-xs uppercase tracking-[0.16em] text-cyan-100 sm:mb-5 sm:px-4 sm:py-3 sm:text-sm sm:tracking-[0.24em]">
          Commissions Closed
        </p>
      )}
      <nav aria-label="Primary" className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-5 lg:gap-6">
        {navigationItems.map((item, index) => (
          <NavigationButton key={item.to} to={item.to} index={index}>
            {item.label}
          </NavigationButton>
        ))}
      </nav>
    </div>
  );
}
